// hooks/useVideoProject.ts
import { useEffect, useState } from 'react';
import {
  ProjectImage,
  VideoProject,
  videoProjectService
} from 'services/videoService';

export const useVideoProject = (projectId: string | null) => {
  const [project, setProject] = useState<VideoProject | null>(null);
  const [images, setImages] = useState<ProjectImage[]>([]);
  const [currentImage, setCurrentImage] = useState<ProjectImage | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const [videoUrl, setVideoUrl] = useState('');
  const [videoLoading, setVideoLoading] = useState(true);
  const [videoError, setVideoError] = useState<string | null>(null);

  const fetchVideoUrl = async (id: string) => {
    try {
      setVideoLoading(true);
      setVideoError(null);
      const response = await videoProjectService.getVideoUrl(id);

      if (response?.video_url) {
        setVideoUrl(response.video_url);
        setVideoLoading(false);
      } else {
        throw new Error('No video URL returned from API');
      }
    } catch (err) {
      console.error('Error fetching video URL:', err);
      setVideoError('Erro ao obter URL do vídeo');
      setVideoLoading(false);
    }
  };

  useEffect(() => {
    if (!projectId) {
      setError('ID do projeto não fornecido');
      setLoading(false);
      return;
    }

    const loadProject = async () => {
      try {
        setLoading(true);
        setError(null);

        const projects = await videoProjectService.getAll();
        const selectedProject = projects.find(p => String(p.id) === projectId);

        if (!selectedProject) {
          throw new Error('Projeto não encontrado');
        }

        /*if (!selectedProject.video_filename) {
          throw new Error('Este projeto não possui vídeo disponível');
        }*/

        setProject(selectedProject);

        const projectImages = await videoProjectService.getProjectImages(
          projectId
        );
        const sortedImages = projectImages.sort(
          (a, b) =>
            new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
        );
        setImages(sortedImages);

        if (sortedImages.length > 0) {
          setCurrentImage(sortedImages[0]);
        }

        await fetchVideoUrl(projectId);
      } catch (err) {
        console.error('Error loading project:', err);
        setError((err as Error)?.message || 'Erro ao carregar projeto');
      } finally {
        setLoading(false);
      }
    };

    loadProject();
  }, [projectId]);

  return {
    project,
    images,
    currentImage,
    loading,
    error,
    videoUrl,
    videoLoading,
    videoError,
    setCurrentImage,
    fetchVideoUrl
  };
};
